import { Case } from "../../../api/cases";
import {
  KEY_PERSONNEL_RELATED_AS,
  RELATED_AS_LABELS,
  RelatedAs,
} from "../../../api/stakeholder_relationships";


export const getAccountNames = (case_data: Case): string[] =>
  Array.from(
    new Set(
      [
        ...(case_data.credit_accounts ?? []).map(
          (account) => account.account_name || account.account_number,
        ),
        ...(case_data.accounts ?? []).map(
          (account) => account.account_name || account.account_number,
        ),
      ].filter(Boolean),
    ),
  );


export const getKeyPersonnel = (case_data: Case): string[] => {
  const nameByStakeholderId = new Map(
    (case_data.stakeholders ?? []).map((stakeholder) => [
      stakeholder.stakeholder_id,
      stakeholder.name,
    ]),
  );

  const stakeholderToRolesMap: Record<string, Set<RelatedAs>> = 
    (case_data.stakeholder_relationships ?? [])
        .filter((relationship) =>
          KEY_PERSONNEL_RELATED_AS.has(relationship.related_as),
        ).reduce((accoumulator, relationship) => {
          accoumulator[relationship.stakeholder_id] = accoumulator[relationship.stakeholder_id] ? accoumulator[relationship.stakeholder_id].add(relationship.related_as) : new Set<RelatedAs>([relationship.related_as]);
          return accoumulator;
        }, {} as Record<string, Set<RelatedAs>>);

  const result = Object.entries(stakeholderToRolesMap).map(([stakeholderId, roles]) =>{
    const name = nameByStakeholderId.get(stakeholderId);
    const roleLabels = roles.values().map((role) => RELATED_AS_LABELS[role]).toArray().join(", ")
    return `${name}(${roleLabels})`;
  });

  return result;
};
